<!-- 油卡管理 -->
<template>
    <div class="new-cell-group">
        <template v-if="!isInitialized">
            <div class="card-container">
                <div class="card-option">
                    <van-empty description="正在读取中..."/>
                </div>
            </div>
        </template>
        <template v-if="!cardList.length && isInitialized">
            <apply-card/>
        </template>
        <template v-if="cardList.length && isInitialized">
            <van-row class="top-menu">
                <van-col class="top-menu-secelet after-divider" :span="12" @click="$router.push({ name : 'Binding'})">
                    <span>绑定油卡</span>
                </van-col>
                <van-col class="top-menu-secelet" :span="12" @click="$router.push({ name : 'CardHandle'})">
                    <span>一键办卡</span>
                </van-col>
            </van-row>
            <swiper ref="cardSwiper"
                    :options="swiperOptions"
                    @slide-change="onSlideChange"
            >
                <swiper-slide v-for="(item, index) in cardList" :key="'card'+index">
                    <card-design :card-info="item"/>
                </swiper-slide>
                <div v-show="cardList.length > 1">
                    <div class="swiper-pagination" slot="pagination"></div>
                </div>
            </swiper>
            <van-cell-group>
                <van-cell title="油卡类型" :title-style="{'font-weight': 'bold'}" :value="cardInfo.type_text"/>
                <van-cell title="等级" :title-style="{'font-weight': 'bold'}" :value="cardInfo.level_text"/>
                <van-cell title="积分" :title-style="{'font-weight': 'bold'}" :value="cardInfo.integral" />
                <van-cell title="有效期至" :title-style="{'font-weight': 'bold'}" :value="cardInfo.validity_time || '永久有效'"/>
                <!--<van-cell title="办卡时间" :value="cardInfo.created_at | dateFormat('yyyy-MM-dd')" />-->
                <van-cell title="办卡站点" :value="cardInfo.handle_site_text"/>
                <van-cell title="待圈存金额" v-if="cardInfo.open_data && cardInfo.open_data.wait_refresh_amount" :value="'￥' + cardInfo.open_data.wait_refresh_amount"/>
                <van-cell title="绑定卡号" v-if="cardInfo.source_type == 'entity_card'" :value="cardInfo.open_data.bind_card_no"/>
                <van-cell style="padding: 0;">
                    <template>
                        <van-grid class="options-container" :column-num="3">
                            <van-grid-item v-for="(item, index) in optionData" :key="index" @click="$router.push({ name : item.link, query: { user_card_id : cardInfo.id } })">
                                <svg class="icon" aria-hidden="true">
                                    <use :xlink:href="item.icon"></use>
                                </svg>
                                <div style="margin-top: 10px; font-size: 0.35rem;">{{item.text}}</div>
                            </van-grid-item>

                            <van-grid-item v-if="cardInfo.source_type === 'entity_card'" @click="toUnbind">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-jiebang"></use>
                                </svg>
                                <div style="margin-top: 10px; font-size: 0.35rem;">解绑实体卡</div>
                            </van-grid-item>

                            <van-grid-item  v-if="cardInfo.is_handle_secondary_card" @click="inviteSecondaryCard">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-yqhy"></use>
                                </svg>
                                <div style="margin-top: 10px; font-size: 0.35rem;">邀请使用副卡</div>
                            </van-grid-item>
                            <van-grid-item  v-if="cardInfo.type === 'SecondaryCard'" @click="unbindSecondary">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-unlink"></use>
                                </svg>
                                <div style="margin-top: 10px; font-size: 0.35rem;">解绑副卡</div>
                            </van-grid-item>


                            <van-grid-item  v-if="!cardInfo.is_default" @click="toDefault">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-sheweimoren"></use>
                                </svg>
                                <div style="margin-top: 10px; font-size: 0.35rem;">设为默认</div>
                            </van-grid-item>
                        </van-grid>
                    </template>
                </van-cell>
            </van-cell-group>
        </template>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.css'
    import api from '../../assets/js/api'
    import cardDesign from '../../components/beilin/CardDesign'
    import ApplyCard from '../../components/beilin/ApplyCard'

    export default {
        name: 'Index',
        components: {ApplyCard, swiper, swiperSlide, cardDesign},
        data () {
            return {
                loading: false,
                cardList: [],
                cardIndex : 0,
                swiperOptions: {
                    effect: 'coverflow',
                    slidesPerView: 'auto', //显示个数
                    spaceBetween : '14%', //轮播元素边距
                    centeredSlides : true, //轮播元素居中
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        depth: 160, //z轴的距离，越大轮播元素越小
                        modifier: 1,
                        slideShadows: false,
                    },
                    pagination: {
                        el: '.swiper-pagination' //分页器类名
                    },
                },
                isInitialized: false,

            }
        },
        computed: {
            cardInfo() {
                return this.cardList[this.cardIndex] || {}; //获取轮播节点
            },
            optionData(){
                return [
                {
                    text: '充值',
                    icon: '#icon-chongzhi',
                    link: 'Recharge',
                },
                {
                    text: '消费记录',
                    icon: '#icon-xiaofeijilu',
                    link: 'ConsumeLog'
                },
                {
                    text: '积分记录',
                    icon: '#icon-jifenjilu',
                    link: 'IntegralLog'
                },
                {
                    text: '划拨余额',
                    icon: '#icon-huabo',
                    link: 'CompanyCardTransfer',
                    display: this.cardInfo.open_data && this.cardInfo.open_data.is_master
                },
                {
                    text: '管理副卡',
                    icon: '#icon-wodekapian',
                    link: 'SecondaryCardUserList',
                    display: this.cardInfo.is_handle_secondary_card
                }].filter(item => {
                    return item.display === undefined || item.display === true
                })
            },
            // 油卡类型
            cardType () {
                return (key) => {
                    // 判断store数据是否加载完
                    if (!key) return
                    return this.$store.state.systemEnum.card_type[key].name
                }
            }
        },

        watch: {
            'cardIndex':function (newVal, oldVal) {
                this.$nextTick(function () {
                    this.$refs.cardSwiper.swiper.slideTo(newVal);
                });
            }
        },

        mounted() {
            // 不在created中请求，那时swiper还未挂载
            this.getCardList()
        },

        methods: {
            // 轮播元素变动时触发
            onSlideChange () {
                this.cardIndex = this.$refs.cardSwiper.swiper.activeIndex //轮播元素下标
            },

            // 跳转至绑卡页面
            toBinding () {
                this.$router.push({name: 'Binding'})
            },

            // 设置默认卡
            toDefault () {
                api.request('/user_card/set_default', {
                    user_card_id: this.cardInfo.id
                }).then(res => {
                    this.$notify({ type: 'success', message: '设置成功' })
                    this.getCardList()
                })
            },

            toUnbind () {
                this.$dialog.confirm({
                    title: '警告',
                    message: '是否要解绑该卡？',
                }).then(() => {
                    api.request('/user_card/unbind_entity_card', {
                        user_card_id: this.cardInfo.id
                    }).then(res => {
                        this.$notify({ type: 'success', message: '设置成功' })
                        this.getCardList()
                    })      
                }).catch(() => {});      
            },

            // 获取数据
            getCardList () {
                api.request('/user_card/list').then(res => {
                    this.cardList = res.data;
                    for(let index in res.data){
                        if(res.data[index].is_default){
                            this.cardIndex = index
                        }
                    }
                    this.isInitialized = true;
                })
            },

            inviteSecondaryCard() {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '正在生成邀请链接',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_card/get_use_secondary_card_invite', {
                    user_card_id: this.cardInfo.id
                }).then(res => {
                    self.$toast.clear(toast);
                    self.$dialog.alert({
                        message: '邀请信息生成成功，请点击右上角选择“发送给朋友”进行邀请',
                    });
                    wx.updateAppMessageShareData({ 
                        title: '邀请加入',
                        desc: '邀请绑定副卡',
                        link: `${window.location.origin}/${self.$route.params.companyId}/card/secondary_card_invite?id=${res.data.id}`,
                        imgUrl: self.inviteImg
                    });
                    console.log(`${window.location.origin}/${self.$route.params.companyId}/card/secondary_card_invite?id=${res.data.id}`)
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.loading = false;
                })
            },

            unbindSecondary() {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '解绑中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_card/unbind_secondary_card', {
                    user_card_id: this.cardInfo.id,
                }).then(res => {
                    self.$toast.clear(toast);
                    self.$toast.success(res.msg);
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.getCardList()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            .card-option-button {
                color: #FFF;
                box-shadow: 0px 4px 6px rgba(255, 168, 9, 0.05);
                border-radius: 1rem;
                height: 1rem;
                background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
            }
        }
    }
    .card-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .van-empty {
            padding-top: 0;
        }
    }
    .top-menu {
        background-color: #fff;
        border-bottom: 1px soild #aaa;
        .top-menu-secelet {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;

            span {
                width: 100%;
                text-align: center;
                padding: 10px;
                font-size: 16px;
                display: inline-block;
            }
        }
        .after-divider {
            &::after {
                content: '|'
            }
        }
    }

    .swiper-container{
        padding: 20px 0 30px;
        height: 160px;
        .swiper-slide{
            width: 290px;
            border-radius: 10px;
            box-shadow: 0 0 5px 0 rgba(0,0,0,.4);
        }
        .swiper-slide-active{
            box-shadow: 0 0 10px 0 rgba(0,0,0,.4);
        }
    }
    .van-cell-group{
        .van-cell{
            padding-left: 20px;
            padding-right: 20px;
        }
    }

    .options-container {
        width: 100%; 
        padding: 15px 0; 
        box-sizing: border-box;
        background: #fff;
        .icon{
            font-size: 30px;
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            .swiper-pagination{
                bottom: 0 !important;
                height: 30px;
                line-height: 30px;
                .swiper-pagination-bullet{
                    width: 10px;
                    height: 10px;
                    border-radius: 15px;
                    transition: width 0.3s;
                }
                .swiper-pagination-bullet-active{
                    background: themed('colorTag');
                    width: 20px;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/card/Index.vue